import { create } from 'zustand';
import { FinanceLedgerNavigationSchema, type NavigationContext } from '@aegislab/shared';

export interface FinanceLedgerFilters {
  readonly period: string | null;
  readonly budgetType: 'all' | 'TEAM' | 'WORLD' | 'FLEX';
  readonly teamFilter: string;
  readonly reviewOnly: boolean;
}

interface FinanceLedgerFilterStore {
  readonly filters: FinanceLedgerFilters;
  setFilters: (filters: Partial<FinanceLedgerFilters>) => void;
}

export const useFinanceLedgerFilters = create<FinanceLedgerFilterStore>((set) => ({
  filters: { period: null, budgetType: 'all', teamFilter: 'all', reviewOnly: false },
  setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
}));

export function financeLedgerFiltersFromContext(context: NavigationContext | undefined) {
  const parsed = FinanceLedgerNavigationSchema.safeParse(context);
  if (!parsed.success) return null;
  const { ledgerPeriod, ledgerPool, ledgerTeam, ledgerReview } = parsed.data;
  return {
    period: ledgerPeriod,
    budgetType: ledgerPool,
    teamFilter:
      ledgerPool === 'WORLD' ||
      ledgerPool === 'FLEX' ||
      (ledgerPool === 'TEAM' && ledgerTeam === 'global')
        ? 'all'
        : ledgerTeam,
    reviewOnly: ledgerReview === 'true',
  };
}
